import { handleActions, createAction } from 'redux-actions';
import deepmerge from 'deepmerge';
// import ggLogoColor from 'assets/goodway_logo_color.svg';
import ggUpdatedLogoWhite from 'assets/goodway-group-logo-white.svg';
import cveLogoWhite from 'assets/cve_logo_white.png';
import cveLogoTextWhite from 'assets/cve_logo_text_white.png';
import cveLogoColor from 'assets/cve_logo_color.png';
import cveLogoTextColor from 'assets/cve_logo_text_color.png';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';
import isValidColor from 'helpers/isValidColor';
import { colors as brandColors } from 'services/theme/brandTheme/brandColors';
import { get } from 'lodash';
// Actions
export const actions = mapActions([
    'UPDATE_THEME_STYLES',
    'SHOW_GG_BRANDING',
    'HIDE_GG_BRANDING',
    'SET_ORGANIZATION_BRANDING_CODE',
    'MERGE_PAGE_THEME_DEFAULTS',
], 'THEME');

export const updateThemeStyles = createAction(actions.UPDATE_THEME_STYLES);
export const showGGBranding = createAction(actions.SHOW_GG_BRANDING);
export const hideGGBranding = createAction(actions.HIDE_GG_BRANDING);
export const setOrganizationBrandingCode = createAction(actions.SET_ORGANIZATION_BRANDING_CODE);
export const mergePageThemeDefaults = createAction(actions.MERGE_PAGE_THEME_DEFAULTS);

const tacticIcons = {
    display: 'icon-display-fill',
    mobile: 'icon-mobile-fill',
    native: 'icon-native-fill',
    video: 'icon-video-fill',
    tv: 'icon-tv-fill',
    sem: 'icon-sem-fill',
    all: 'icon-summary'
};

const colors = {
    black: brandColors.black.hex,
    bluemine: brandColors.goodwayBlue[600].hex,
    celery: brandColors.green[400].hex,
    chinchilla: brandColors.sand[400].hex,
    chino: brandColors.sun[100].hex,
    darkgray: brandColors.sand[500].hex,
    flamepea: brandColors.red[400].hex,
    gray: brandColors.sand[200].hex,
    graysuit: brandColors.sand[100].hex,
    lightgray: brandColors.sand[100].hex,
    lochmara: brandColors.goodwayBlue[400].hex,
    tangerine: brandColors.sun[400].hex,
    primary: brandColors.goodwayBlue[400].hex,
    secondary: brandColors.sand[100].hex,
    shakespeare: brandColors.goodwayBlue[50].hex,
    positive: brandColors.green[400].hex,
    negative: brandColors.red[400].hex,
    neutral: brandColors.sand[200].hex,
    white: brandColors.white.hex,
};

// Original Graph Colors
// const orderedColors = [
//     brandColors.goodwayBlue[400].hex,
//     '#D03829',
//     '#93B6B0',
//     '#B6AD46',
//     '#8F4F68',
//     '#66BB83',
//     '#5A80C4',
//     '#465D39',
//     '#D78E52',
//     '#57C4C8'
// ];

const orderedColors = [
    brandColors.goodwayBlue[400].hex,
    brandColors.red[400].hex,
    brandColors.green[400].hex,
    '#51159D',
    '#E97D19',
    brandColors.goodwayBlue[600].hex,
    brandColors.red[600].hex,
    brandColors.green[600].hex,
    '#976302',
    brandColors.midnightBlue[100].hex,
];

const breakpoints = {
    xs: 0,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 4000
};

const initialState = {
    breakpoints,
    tactics: {
        display: {
            icon: tacticIcons.display
        },
        mobile: {
            icon: tacticIcons.mobile
        },
        native: {
            icon: tacticIcons.mobile
        },
        video: {
            icon: tacticIcons.video
        },
        tv: {
            icon: tacticIcons.tv
        },
        sem: {
            icon: tacticIcons.sem
        },
        all: {
            icon: tacticIcons.all
        }
    },
    colors,
    orderedColors,
    global: {
        colors: {
            border: colors.gray,
            background: colors.white,
            headerBarColor: colors.black,
            sideBarColor: colors.bluemine,
            highlightColor: colors.tangerine,
            buttonColor: colors.primary
        },
        constrastThresholdsFromWhite: {
            headerBarBorder: 2,
            sideBarBorder: 2,
        },
        borders: {
            layout: '1px solid #ccc',
        },
        images: {
            cveLogoWhite,
            cveLogoTextWhite,
            cveLogoColor,
            cveLogoTextColor,
            mainLogo: ggUpdatedLogoWhite,
            entityLogo: null,
            brandLogo: null
        },
        logoMap: {
            default: {
                width: 142,
                height: 20,
                image: 'mainLogo'
            },
            cveLogoTextWhite: {
                width: 80,
                height: 56,
                image: 'cveLogoTextWhite'
            },
            cveLogoTextColor: {
                width: 80,
                height: 56,
                image: 'cveLogoTextColor'
            },
            cveLogoTextColorWhiteBG: {
                width: 80,
                height: 56,
                image: 'cveLogoTextColor',
                backgroundColor: '#FFF'
            },
            cveLogoWhite: {
                width: 80,
                height: 56,
                image: 'cveLogoWhite'
            },
            cveLogoColor: {
                width: 80,
                height: 56,
                image: 'cveLogoColor'
            },
            cveLogoColorWhiteBG: {
                width: 80,
                height: 56,
                image: 'cveLogoColor',
                backgroundColor: '#FFF'
            }
        }
    },
    forms: {
        header: '#000',
        subheader: colors.darkgray,
        placeholder: '#C1C1C1',
        radiofill: colors.primary
    },
    charts: {
        axisAssets: colors.darkgray,
        sparkline: colors.primary,
        boxPlotFill: '#81BFDC',
        colors: {
            title: colors.darkgray
        },
        TwoAxisBarWithLineChart: {
            color: colors.bluemine,
            marker: {
                lineWidth: 1,
                lineColor: '#fff'
            }
        }
    },
    callouts: {
        colors: {
            value: colors.black,
            title: colors.darkgray,
            helptext: colors.darkgray,
            helpicons: colors.darkgray,
            helptitle: colors.primary,
            categories: '#C1C1C1',
            // NOTE: ML-1514 & ML-1540 adjusted colors
            positive: colors.darkgray,
            negative: colors.darkgray,
            neutral: colors.neutral
        },
        icons: {
            positive: 'icon-arrow-increase',
            negative: 'icon-arrow-decrease',
            neutral: 'icon-remove'
        }
    },
    channelCallouts: {
        colors: {
            channelNameBackground: colors.primary,
            channelName: colors.white,
            linkBackground: colors.white,
            linkText: '#007DC6',
            linkArrow: colors.primary,
            linkHover: '#F1F1F1',
            linkBorder: colors.gray,
            calloutTitle: '#797979',
            divider: '#F1F1F1'
        }
    },
    insights: {
        colors: {
            iconbackground: colors.darkgray,
            icon: colors.white,
            title: colors.darkgray,
            data: colors.black
        },
        icons: {
            creative: 'icon-arrow-resize'
        },
    },
    font: {
        primary: '\'Lato\', sans-serif'
    },
    whitelabel: {
        showGGBranding: true,
        organizationBrandingCode: null
    }
};

export default handleActions({

    [actions.UPDATE_THEME_STYLES]: (state, action) => {
        const colorsToUpdate = [
            'headerBarColor',
            'sideBarColor',
            'highlightColor',
            'buttonColor'
        ].reduce((prev, colorKey) => {
            const color = get(
                action.payload,
                ['brandBranding', colorKey],
                get(action.payload, ['brand', 'branding', colorKey])
            );

            if (color && isValidColor(color)) {
                prev[colorKey] = { $set: color };
            } else {
                prev[colorKey] = { $set: initialState.global.colors[colorKey] };
            }

            return prev;
        }, {});

        const updatedData = {
            global: {
                colors: colorsToUpdate,
                images: {
                    entityLogo: { $set: action.payload.entityBranding ? action.payload.entityBranding.logoUrl : null },
                    brandLogo: { $set: action.payload.brandBranding ? action.payload.brandBranding.logoUrl : null },
                }
            }
        };

        return update(state, updatedData);
    },

    [actions.SHOW_GG_BRANDING]: state => update(state, {
        whitelabel: {
            showGGBranding: { $set: true }
        }
    }),

    [actions.HIDE_GG_BRANDING]: state => update(state, {
        whitelabel: {
            showGGBranding: { $set: false }
        }
    }),

    [actions.SET_ORGANIZATION_BRANDING_CODE]: (state, action) => update(state, {
        whitelabel: {
            organizationBrandingCode: { $set: action.payload || null }
        }
    }),

    [actions.MERGE_PAGE_THEME_DEFAULTS]: (state, action) => update(state, {
        $merge: deepmerge(state, action.payload)
    })
}, initialState);



// WEBPACK FOOTER //
// ./src/services/theme/duck.js